// extracted by mini-css-extract-plugin
export default {"footer":"XMpPdkLegfIsoXQqV4hU"};